import React from "react";

const Writing = () => {
  return (
    <div className="row work">
      <div className="three columns header-col">
        <h1>
          <span>Writing</span>
        </h1>
      </div>

      <div className="nine columns main-col">
        <div className="row item">
          <div className="twelve columns">
            <h3>
              <a
                href="https://orianaredstar.wixsite.com/fanoosmagazine"
                target="_blank"
              >
                Fanoos Magazine: The Lantern-Bellydance Quarterly
              </a>
            </h3>
            <p className="info">
              Shimmy Your Way into those Search Results!
              <span>&bull;</span>
              <em className="date">Spring 2020</em>
            </p>
            <p>
              Let’s do a quick exercise. Open your search engine of choice (mine
              is Google) and type in “bellydance” followed by your city. Take a
              look at the results. Are you in there? Well done! You’ve mastered
              the art of Search Engine Optimization (SEO). If you aren’t there,
              try searching for your name and city. Are you there now? Great,
              you’re doing pretty good, but wouldn’t you prefer to be in that
              first search? If you aren’t, don’t worry I’m here to help you.
              With a few tweaks we can set you on your way to rising in the
              search results.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Writing;
